/* eslint-disable no-console */
import React, { useContext } from 'react';
import { Menu, Grid, Stack, Box, Typography, Tooltip, Avatar } from '@mui/material';
import { IoClose, IoCopyOutline } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { LanguageContext } from '../../libs/Context';

const NoQRShareMenu = ({ anchorEl, open, handleClose, link, title, socialMediaIcons }) =>
{
	const { language } = useContext(LanguageContext);

	const handleCopyLink = () =>
	{
		navigator.clipboard.writeText(link).then(() =>
		{
			toast.success(language.youHaveCopiedSuccessfully);
		})
			.catch((error) =>
			{
				console.error('Failed to copy: ', error);
			});
	};

	return (
		<Menu
			id='share-menu'
			anchorEl={anchorEl}
			open={open}
			onClose={handleClose}
			MenuListProps={{ 'aria-labelledby': 'share-button' }}
			PaperProps={{
				sx : {
					width        : '500px',
					borderRadius : '13px'
				}
			}}
		>
			<Grid container direction='column' px='var(--pixel16)' py='var(--pixel8)'>
				<Stack direction='row' justifyContent='space-between' width='var(--percent100)'>
					<Typography fontWeight='var(--font500)'>{title}</Typography>
					<IoClose fontSize='var(--pixel22)' style={{ cursor: 'pointer' }} color='#9095A0' onClick={handleClose} />
				</Stack>
				<Grid item width='var(--percent100)'>
					<Stack direction='row' pt='var(--pixel16)' pb='var(--pixel8)' justifyContent='space-between' spacing={1} width='var(--percent100)'>
						<Box sx={{ border: '1px solid var(--grayDF)', width: '90%', borderRadius: '6px', display: 'flex', alignItems: 'center' }} p='var(--pixel8)'>
							<Typography sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} variant='body2'>
								{link}
							</Typography>
						</Box>
						<Tooltip title={language.copy} placement='bottom'>
							<Box sx={{ border: '1px solid var(--grayDF)', display: 'flex', borderRadius: '6px', alignItems: 'center', justifyContent: 'center' }} p='var(--pixel8)'>
								<IoCopyOutline
									color='var(--primaryColor)'
									style={{ cursor: 'pointer' }}
									onClick={handleCopyLink}
								/>
							</Box>
						</Tooltip>
					</Stack>
					<Stack direction='row' spacing={2} pt='var(--pixel8)'>
						{socialMediaIcons.map((item) => (
							<a
								key={item?.key}
								href={`${item?.urlTemplate}${encodeURIComponent(link)}`}
								target='_blank'
								rel='noopener noreferrer'
							>
								<Avatar
									src={item?.imgUrl}
									alt={item?.key}
									sx={{ width: 40, height: 40, border: '1px solid var(--grayDF)', borderRadius: '13%', padding: 'var(--pixel8)' }}
									variant='rounded'
								/>
							</a>
						))}
					</Stack>

				</Grid>
			</Grid>
		</Menu>
	);
};

export default NoQRShareMenu;
